import { Col, Row } from "./layout.jsx";
import {
  Request,
  RequestFooter,
  RequestHeader,
  RequestHeaderItem,
  RequestHeaderLine,
} from "./requests.jsx";
import { color, styled, theme } from "../util/style.js";

import { format } from "../../common/date.js";
import { formatCurrency } from "../../common/currency.js";

export const Container = styled(Request)`
  background: ${color("white-grey")};
`;

const VoucherAmountBetter = styled.span`
  color: ${color("primary")};
  font-weight: ${theme("font-weight-bold")};
`;

export default styled(function MyProshopVoucherItem({
  className,
  ...voucherProps
}) {
  const {
    id,
    usedAt,
    voucherCode,
    amount,
    shopAmount,
    expirationDate,
    validated,
  } = voucherProps;

  // Si créé il y a moins de X minutes
  const isRecenltyUsed = (new Date() - new Date(usedAt)) / 1000 / 60 < 30; // minutes

  const isExpired = new Date(expirationDate) - new Date() < 0;

  return (
    <Container
      className={className}
      highlight={isRecenltyUsed}
      disabled={validated}
    >
      <RequestHeader>
        <RequestHeaderLine>
          <RequestHeaderItem strong>
            Code My Proshop : {voucherCode || "-"}
          </RequestHeaderItem>
          <RequestHeaderItem strong right primary={isRecenltyUsed}>
            {formatCurrency(amount)}
            {shopAmount && amount !== shopAmount && (
              <VoucherAmountBetter>
                {` → ${formatCurrency(shopAmount)}`}
              </VoucherAmountBetter>
            )}
          </RequestHeaderItem>
        </RequestHeaderLine>
        <RequestHeaderLine>
          <RequestHeaderItem small>
            {validated
              ? `Bon déjà utilisé`
              : isExpired
              ? `Bon expiré`
              : `Créé le ${format(usedAt)}`}
          </RequestHeaderItem>
          <RequestHeaderItem small right>
            {validated
              ? ``
              : isExpired
              ? `Expiré le ${format(expirationDate)}`
              : `Expire au ${format(expirationDate)}`}
          </RequestHeaderItem>
        </RequestHeaderLine>
      </RequestHeader>

      <RequestFooter>
        <div>
          {validated
            ? `Vous avez déjà utilisé ce bon pour une commande`
            : isExpired
            ? `Ce bon est expiré.`
            : `Indiquez ce code dans votre commande sur My Proshop pour bénéficier d'une remise de ${formatCurrency(
                shopAmount,
              )} HT.`}
        </div>
      </RequestFooter>
    </Container>
  );
})``;
